import "@fontsource/caveat/400.css";
import "@fontsource/caveat/700.css";
import "./styles/app.css";

import { StrictMode } from "react";
import { createRoot } from "react-dom/client";

import { App } from "./App";
import { createGameController } from "./game/create";
import { getWebApp } from "./lib/telegram";
import { GameProvider } from "./ui/context";

const tg = getWebApp();
if (tg) {
  tg.ready();
  tg.expand();
  tg.disableVerticalSwipes?.();
  // Высота видимой области Telegram (клавиатура, шторка) → CSS-переменная
  const setViewportHeight = () => {
    if (tg.viewportStableHeight) {
      document.documentElement.style.setProperty(
        "--tg-viewport-stable-height",
        `${tg.viewportStableHeight}px`,
      );
    }
  };
  setViewportHeight();
  tg.onEvent?.("viewportChanged", (event) => {
    if (event?.isStateStable) setViewportHeight();
  });
}

// Контроллер живёт всё время работы приложения и запускается один раз, вне React
// (иначе StrictMode в dev дважды выполнил бы init и подключение к комнате).
const controller = createGameController();
void controller.init();

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <GameProvider controller={controller}>
      <App />
    </GameProvider>
  </StrictMode>,
);
